import React from 'react';

// Desktop Invite Forms — the two slots side by side.
export default function InviteFormsDesktop({ vm }) {
  const { allowed, hasEvent, eventTitle, slots, pick, upload } = vm;

  if (!allowed || !hasEvent) {
    return (
      <div>
        <div className="page-head"><h1>Invite Forms</h1></div>
        <div className="card card-pad empty">
          {!allowed ? 'You do not have access to invite forms.' : 'Select an event before uploading invite forms.'}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head">
        <h1>Invite Forms</h1>
        <span className="muted">{eventTitle}</span>
      </div>
      <div className="muted" style={{ marginBottom: 12, fontSize: 13 }}>
        These files are sent when a guest gets an <strong>Image</strong> or <strong>PDF</strong> invite on WhatsApp. They are kept on this browser only.
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 14, maxWidth: 900 }}>
        {slots.map(slot => (
          <div key={slot.kind} className="card card-pad">
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 8 }}>
              <strong style={{ fontSize: 16 }}>{slot.title}</strong>
              <div style={{ flex: 1 }} />
              <span className={slot.media?.url ? 'chip ok' : 'chip pend'}>{slot.media?.url ? 'Ready' : 'Not set'}</span>
            </div>
            <label className="field">Upload file
              <input type="file" accept={slot.accept} disabled={slot.busy} onChange={e => pick(slot.kind, e.target.files?.[0])} />
            </label>
            {slot.picked && <div className="muted" style={{ fontSize: 13 }}>{slot.picked.name}</div>}
            {slot.media?.url && (
              <div className="muted" style={{ fontSize: 13, marginTop: 6 }}>
                Current: {slot.media.name || slot.media.url} · <a href={slot.media.url} target="_blank" rel="noreferrer">Open</a>
              </div>
            )}
            <div style={{ marginTop: 10, textAlign: 'right' }}>
              <button type="button" className="btn primary" disabled={slot.busy || !slot.picked} onClick={() => upload(slot.kind)}>
                {slot.busy ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
